export const SEGMENTS = {
    FINANCIAL_ADVISORY: 'FINANCIAL_ADVISORY',
    ADVISORY_WORKSHOP: 'ADVISORY_WORKSHOP',
    ACCESS_NEW_MARKETS: 'ACCESS_NEW_MARKETS',
    NETWORKING_SESSION: 'NETWORKING_SESSION'
}
export const SEGMENTS_DATA = Object.keys(SEGMENTS).map((seg, index) => ({
    index,
    value: seg
}))